<template>
	<PayImageWallShell
		:data="data"
		:block-id="blockId"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import PayImageWallShell from '../shared/PayImageWallShell.vue';

	export default {
		name: 'GBlockPayImageWall',
		components: { PayImageWallShell },
		props: {
			data: {
				type: Object,
				required: true,
			},
			blockId: {
				type: String,
				default: '',
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
	};
</script>
